<ng-container *transloco="let t">
    <!-- Breadcrumb -->
    <div class="breadcrumb-card mb-25 d-md-flex align-items-center justify-content-between">
        <h5 class="mb-0">
            {{t('create')}} {{t('user')}}
        </h5>
        <ol class="breadcrumb list-unstyled mt-0 mb-0 pl-0">
            <li class="breadcrumb-item position-relative">
                {{t('Masters')}}
            </li>
            <li class="breadcrumb-item position-relative">
                <a routerLink="/masters/company-users" class="d-inline-block position-relative">
                    {{t('Company Users')}}
                </a>
            </li>
            <li class="breadcrumb-item position-relative">
                {{t('create')}} {{t('user')}}
            </li>
        </ol>
    </div>

    <!-- Create Company User -->
    <mat-card class="altair-card create-company-card mb-25 border-radius bg-white border-none d-block"
        [class.rtl-enabled]="themeService.isRTLEnabled()">
        <mat-card-content>
            <form [formGroup]="addCompanyUserForm">
                <div class="row">
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('email-adress')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-email-address')}}
                                </mat-label>
                                <input matInput type="text" id="email" formControlName="email" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('password')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-your-password')}}
                                </mat-label>
                                <input matInput [type]="hide ? 'password' : 'text'" id="password"
                                    formControlName="password" required>
                                <button mat-icon-button matSuffix (click)="hide = !hide"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
                                    <span class="material-symbols-outlined">
                                        {{hide ? 'visibility_off' : 'visibility'}}
                                    </span>
                                </button>
                            </mat-form-field>
                            <div *ngIf="addCompanyUserForm.invalid && (addCompanyUserForm.get('password')!.dirty || addCompanyUserForm.get('password')!.touched)"
                                class="error text-danger">
                                <div *ngIf="addCompanyUserForm.get('password')!.hasError('pattern')">
                                    {{t('pattern-password')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('confirm-password')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('confirm-password')}}
                                </mat-label>
                                <input matInput [type]="hide2 ? 'password' : 'text'" id="confirmPassword"
                                    formControlName="confirmPassword" required>
                                <button mat-icon-button matSuffix (click)="hide2 = !hide2"
                                    [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
                                    <span class="material-symbols-outlined">
                                        {{hide2 ? 'visibility_off' : 'visibility'}}
                                    </span>
                                </button>
                            </mat-form-field>
                            <div *ngIf="addCompanyUserForm.invalid && (addCompanyUserForm.get('confirmPassword')!.dirty || addCompanyUserForm.get('confirmPassword')!.touched)"
                                class="error text-danger">
                                <div *ngIf="addCompanyUserForm.get('confirmPassword')!.hasError('pattern')">
                                    {{t('pattern-password')}}
                                </div>
                                <div *ngIf="addCompanyUserForm.get('confirmPassword')!.hasError('confirmedValidator')">
                                    {{t('passwords-did-not-match')}}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('name')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-name')}}
                                </mat-label>
                                <input matInput type="text" id="name" formControlName="name" required>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('role')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-role')}}
                                </mat-label>
                                <mat-select formControlName="role" required>
                                    <mat-option *ngFor="let role of roles" [value]="role">
                                        {{role.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('company')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-company')}}
                                </mat-label>
                                <mat-select [(value)]="selectedCompany"
                                    (selectionChange)="changeCompany(selectedCompany)" required>
                                    <mat-option *ngFor="let company of companies" [value]="company.id">
                                        {{company.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('branch-office')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-branch-office')}}
                                </mat-label>
                                <mat-select formControlName="branchOffice" required>
                                    <mat-option *ngFor="let branchOffice of branchOffices" [value]="branchOffice">
                                        {{branchOffice.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('contact-medium-type')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('select-contact-medium-type')}}
                                </mat-label>
                                <mat-select name="contactMediumType" [(value)]="selectedContactMediumType">
                                   <mat-option [value]="null">{{t('none')}}</mat-option>
                                    <mat-option *ngFor="let contactMediumType of contactMediumTypes"
                                        [value]="contactMediumType">
                                        {{contactMediumType.name}}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-md-4 col-sm-6">
                        <div class="mb-25">
                            <label class="main-label d-block lh-1 text-black">
                                {{t('contact')}}
                            </label>
                            <mat-form-field>
                                <mat-label>
                                    {{t('enter-contact')}}
                                </mat-label>
                                <input matInput type="number" id="contact" formControlName="contact" [required]="selectedContactMediumType != undefined">
                            </mat-form-field>
                        </div>
                    </div>
                </div>
                <div class="btn-box">
                    <button mat-button type="button" (click)="onSubmit()" [disabled]="addCompanyUserForm.invalid">
                        {{t('create')}} {{t('user')}}
                    </button>
                    <a mat-button routerLink="/masters/company-users">
                        {{t('cancel')}}
                    </a>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-container>
